import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google'
import { Icon } from '../../shared/ui/icon/icon.tsx'
import { useAppModule } from '../appContext.ts'
import { useSnapshot } from 'valtio'
import { useNavigate } from 'react-router-dom'

export function GoogleAuthProvider(props: { children: React.ReactNode }) {
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      {props.children}
    </GoogleOAuthProvider>
  )
}

export function GoogleAuthButton() {
  const authStore = useAppModule().authStore
  const { loading } = useSnapshot(authStore.state)
  const navigate = useNavigate()

  const handleGoogleAuth = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      void authStore.loginWithGoogle(tokenResponse.code).then(() => {
        navigate('/')
      })
    },
    flow: 'auth-code',
  })

  return (
    <button
      onClick={() => { handleGoogleAuth(); }}
      disabled={loading}
      className="flex size-48 cursor-pointer items-center justify-center rounded-24 bg-black"
    >
      <Icon iconName="google" />
    </button>
  )
}
